"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pbkdf2Sync = pbkdf2Sync;

var _hash = require("hash.js");

var _util = require("@polkadot/util"); // Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Adapted from https://gist.github.com/calvinmetcalf/91e8e84dc63c75f2aa53


function pbkdf2Sync(password, salt, rounds) {
  var len = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 64;
  var out = new Uint8Array();
  var num = 0;
  var block = Buffer.concat([salt, Buffer.from([0, 0, 0, 0])]);

  while (out.length < len) {
    num++;
    block.writeUInt32BE(num, salt.length); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    var prev = (0, _hash.hmac)(_hash.sha512, password).update(block).digest();
    var md = prev;
    var i = 0;

    while (++i < rounds) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      prev = (0, _hash.hmac)(_hash.sha512, password).update(prev).digest();
      var j = -1;

      while (++j < prev.length) {
        md[j] ^= prev[j];
      }
    }

    out = (0, _util.u8aConcat)(out, md);
  }

  return out.slice(0, len);
}